"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var EmptyListMessage_1 = __importDefault(require("components/Lists/EmptyListMessage"));
var NoResultsMessage = (0, DefaultPropsHoC_1.default)(EmptyListMessage_1.default, {
    title: 'No results found.',
    text: 'Your search returned no results. Try shortening or rephrasing your search.',
});
exports.default = NoResultsMessage;
